import React, { useState } from "react";
import { Route, Redirect, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { authenticateUser } from "../../utils/isAuthenticated";
import Sidebar from "../../components/Sidebar/Sidebar";
import { canAssignStaff, hasPermission, mustChangePassword } from "../../utils/commonutils";

const PrivateRoute = ({
  component: Component,
  requiredPermission,	
  ...rest
}) => {
  const [collapsed, setCollapsed] = useState(true);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (authenticateUser() !== true) {
          return <Redirect to="/login" />;
        }
        if (mustChangePassword() && props.location.pathname !== "/profile") {
          return <Redirect to="/profile" />;
        }
        if (requiredPermission && !hasPermission(requiredPermission) && !canAssignStaff(rest.auth?.role)) {
          return <Redirect to="/dashboard" />;
        }
        return (
          <Sidebar {...props} collapsed={collapsed} setCollapsed={setCollapsed}>
            <Component {...props} collapsed={collapsed} />
          </Sidebar>
        );
      }}
    />
  );
};

PrivateRoute.propTypes = {
  auth: PropTypes.object,
  requiredPermission: PropTypes.string,
};

const mapStateToProps = (state) => ({
  auth: state.authReducer,
});

export default withRouter(connect(mapStateToProps)(PrivateRoute));
